import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageGameManager } from '../voyageGameManager-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageGeneralCommand {
  command: EGeneralCommand
}

export enum EGeneralCommand {
  Pause = 0,
  Unpause = 1,
}

export const voyageMessageId = EVoyageMessage.GeneralCommand

export function write(m: IMessageWriter, d: IMessageGeneralCommand) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write8(m, d.command)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageGeneralCommand = {
    command: messageWriter.read8(m),
  }
  return d
}

export function test() {
  let ex: IMessageGeneralCommand = {
    command: EGeneralCommand.Unpause,
  }
  messageWriter.test('general-command', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  if (msg.command === EGeneralCommand.Pause) {
    voyageGameManager.networkPause(true)
  }
  if (msg.command === EGeneralCommand.Unpause) {
    voyageGameManager.networkPause(false)
  }
}

export function sendMessageAndImmediatelyExecute(msg: IMessageGeneralCommand) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
